import { render, staticRenderFns } from "./BadgeStatusComponent.vue?vue&type=template&id=46d3d148&scoped=true&"
import script from "./BadgeStatusComponent.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./BadgeStatusComponent.vue?vue&type=style&index=0&id=46d3d148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d3d148",
  null
  
)

export default component.exports